import { useState, useEffect } from "react";
import axios from "axios";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ReportGenerator from "./components/ReportGenerator";
import ReportViewer from "./components/ReportViewer";
import NitroReportViewer from "./components/NitroReportViewer";
import NitroReportManager from "./components/NitroReportManager";
import FreshClinicsReportViewerV1 from "./components/FreshClinicsReportViewerV1";
import FreshClinicsV1ReportManager from "./components/FreshClinicsV1ReportManager";
import SavedReports from "./components/SavedReports";
import AmazonQChat from "./components/AmazonQChat";
import Login from "./components/Login";

// Axios interceptor: attach JWT token to every outgoing request
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Axios interceptor: on 401 (except login endpoint), clear token and force re-login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?.url?.includes("/auth/login")
    ) {
      localStorage.removeItem("auth_token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    setIsAuthenticated(!!token);
    setIsLoading(false);
  }, []);

  const handleLogin = (token) => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg text-slate-600">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ReportGenerator onLogout={handleLogout} />} />
          <Route path="/saved-reports" element={<SavedReports onLogout={handleLogout} />} />
          <Route path="/report/:reportId" element={<ReportViewer onLogout={handleLogout} />} />
          <Route path="/nitro-report/:reportId" element={<NitroReportViewer onLogout={handleLogout} />} />
          <Route path="/manage-nitro" element={<NitroReportManager onLogout={handleLogout} />} />
          <Route path="/fresh-clinics-report-v1/:reportId" element={<FreshClinicsReportViewerV1 onLogout={handleLogout} />} />
          <Route path="/manage-fresh-clinics-v1" element={<FreshClinicsV1ReportManager onLogout={handleLogout} />} />
          <Route path="/amazon-q" element={<AmazonQChat onLogout={handleLogout} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
